import { createStatsToken } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toStatsTokenFetchers = function toStatsTokenFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    CreateStatsToken: toFetcher(function () {
      return 'CreateStatsToken';
    }, function () {
      return unwrap(function () {
        return createStatsToken(api);
      });
    })
  };
};